import {
  ConnectedAppAuthType,
  ConnectedAppProvider,
  ConnectedAppProviderAuthPattern,
  ConnectedAppReservedProviderTypes,
  OauthScopes
} from '~/api/types/connectedAppProviders.ts';
import { ConnectionData } from '~/api/types/connectionData.ts';
import { arrayToObjectByKey } from '~/utils/commonUtils.ts';

export enum ConnectedAppConfigurationWorkflow {
  CONNECTION_LIST_EDIT = 'CONNECTION_LIST_EDIT',
  CONNECTION_LIST_CREATE = 'CONNECTION_LIST_CREATE',
  PLAYGROUND_CREATE_CONNECTION = 'PLAYGROUND_CREATE_CONNECTION'
}

const getAuthTypeForProvider = ({
  provider,
  connectedApp,
  authType
}: {
  provider: ConnectedAppProvider;
  connectedApp?: ConnectionData;
  authType?: ConnectedAppAuthType;
}): ConnectedAppProviderAuthPattern => {
  return provider.authPatterns.filter(({ type }) => {
    const authTypeToMatch = type?.toUpperCase() ?? '';
    return (
      authTypeToMatch === authType || authTypeToMatch === connectedApp?.type
    );
  })[0];
};

const allowUseScalekitCredentials = (
  connectionAuthType: ConnectedAppProviderAuthPattern
) => connectionAuthType.oauthConfig?.allowUseScalekitCredentials;

const getScopesMapByScopeNameForConnectedApp = ({
  provider,
  connectedApp
}: {
  provider: ConnectedAppProvider;
  connectedApp: ConnectionData;
}): Record<string, OauthScopes> => {
  const providerScopesMap = arrayToObjectByKey(
    getAuthTypeForProvider({
      provider,
      authType: ConnectedAppReservedProviderTypes.OAUTH2
    })?.oauthConfig?.availableScopes ?? [],
    'scope'
  );
  ((connectedApp.oauthConfig?.scopes ?? []) as string[]).forEach((scope) => {
    if (!providerScopesMap[scope]) {
      providerScopesMap[scope] = {
        scope: scope,
        displayName: scope
      } as OauthScopes;
    }
  });
  return providerScopesMap;
};

export {
  getAuthTypeForProvider,
  allowUseScalekitCredentials,
  getScopesMapByScopeNameForConnectedApp
};
